import {
    exportarHelper,
    useBuscarHelper
} from "../../../Commons/Scripts/Utils/webservice-helper.js"; 
import {
    URL_TARJETAS_DASHBOARD, URL_TOP10_DASHBOARD,
    URL_CLIENTES_AUTOCOMPLETE,
    URL_CLIENTES_GRID_DASHBOARD, URL_EXPORT_CLIENTES_GRID_DASHBOARD, URL_GRAFICO_FACTURAS,
    URL_GRAFICO_FACTURAS_DESCUENTO, URL_GRAFICO_TASAS, URL_GRAFICO_NOTAS_CREDITO, URL_GRAFICO_NOTAS_DEBITO,
    URL_GRAFICO_ANTICIPOS, URL_GRAFICO_RECIBOS, URL_GRAFICO_NOTAS_CREDITO_DEVOLUCION
} from '../../../CxC/Scripts/Constantes/constantes.js'
import {URL_GRAFICOS_FACTURAS_DASHBOARD} from "../../../CxP/Scripts/Utils/constantes";

  export const useBuscarTarjetasDashboard = (cuerpo) => {
    const url = URL_TARJETAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};
  };

  export const useBuscarTop10Dashboard = (cuerpo) => {
    const url = URL_TOP10_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarClientesAutoComplete = (cuerpo) => {
    const url = URL_CLIENTES_AUTOCOMPLETE;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarClientesGrid = (cuerpo) => {
    const url = URL_CLIENTES_GRID_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

export const useBuscarFacturasGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_FACTURAS;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}

export const useBuscarFacturasDescuentoGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_FACTURAS_DESCUENTO;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}

export const useBuscarTasasGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_TASAS;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}

export const useBuscarNotasCreditoGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_NOTAS_CREDITO;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}

export const useBuscarNotasDebitoGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_NOTAS_DEBITO;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}

export const useBuscarAnticiposGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_ANTICIPOS;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}

export const useBuscarRecibosGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_RECIBOS;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}
export const useBuscarNotasCreditoDevolucionGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICO_NOTAS_CREDITO_DEVOLUCION;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
}


export const exportarClientesGrid = async (cuerpo) => {

    try {
        await exportarHelper(URL_EXPORT_CLIENTES_GRID_DASHBOARD, cuerpo);
    } catch (error) {
        console.error("Falló la descarga del reporte:", error);
        alert("Ocurrió un error al generar el reporte. Por favor, intente de nuevo.");
    } finally {
        // Oculta el indicador de carga
        // document.getElementById('spinner').style.display = 'none';
    }
}